import { useAuth } from "@/hooks/useAuth";
import { Navigate } from "react-router-dom";

interface AdminRouteProps {
  children: React.ReactNode;
}

export function AdminRoute({ children }: AdminRouteProps) {
  const { isAdmin } = useAuth();

  if (!isAdmin()) {
    return <Navigate to="/index" replace />;
  }

  return <>{children}</>;
}
